import React from 'react';
import { QueueKey } from 'flow/types/EntityKeys';
import QueueItemsOngoing from './ongoing/QueueItemsOngoing';
import QueueItemsWaiting from './waiting/QueueItemsWaiting';
import TitleOngoingQueueItems from './ongoing/TitleOngoingQueueItems';
import TitleWaitingQueueItems from './waiting/TitleWaitingQueueItems';

interface Props {
    queueKey: QueueKey;
}

const SectionQueueItemsActive = ({ queueKey }: Props) => {
    return (
        <div className="flex flex-col gap-2 antialiased">
            <div className="py-2">
                <TitleWaitingQueueItems queueKey={queueKey} />
                <QueueItemsWaiting queueKey={queueKey} />
            </div>
            <div className="py-2">
                <TitleOngoingQueueItems queueKey={queueKey} />
                <QueueItemsOngoing queueKey={queueKey} />
            </div>
        </div>
    );
};

export default React.memo(SectionQueueItemsActive);
